module.exports = __webpack_public_path__ + "static/assets/9c49ade683c0f0d75796136ff5d1030f.svg";